import { createAsyncThunk } from '@reduxjs/toolkit'
import { taskTrackerApi } from '../../api/taskTracker.api'
import type { TaskTrackerBoardCard } from '../domain.types'
import { getErrorMessage } from '../shared/thunk.utils'

export type FetchDrawerTaskThunkPayload = {
  taskId: number
  boardId: number
  /** Тихий refetch: без drawerTaskLoading / без сброса override при ошибке. */
  silent?: boolean
}

export const fetchDrawerTaskThunk = createAsyncThunk(
  'taskTracker/fetchDrawerTask',
  async (payload: FetchDrawerTaskThunkPayload, { rejectWithValue }) => {
    try {
      const task = await taskTrackerApi.getTask(payload.taskId)
      return { ...payload, task }
    } catch (error: unknown) {
      return rejectWithValue(
        getErrorMessage(error, 'Не удалось загрузить задачу'),
      )
    }
  },
)

export const syncDrawerTaskThunk = createAsyncThunk(
  'taskTracker/syncDrawerTask',
  async (
    payload: {
      taskId: number
      fallbackTask: TaskTrackerBoardCard
    },
    { rejectWithValue },
  ) => {
    try {
      const freshTask = await taskTrackerApi.getTask(payload.taskId)
      return { taskId: payload.taskId, task: freshTask }
    } catch (error: unknown) {
      return rejectWithValue({
        taskId: payload.taskId,
        fallbackTask: payload.fallbackTask,
        error: getErrorMessage(
          error,
          'Не удалось обновить карточку задачи на доске',
        ),
      })
    }
  },
)
